import { createBrowserHistory, History } from 'history';

export const history = createBrowserHistory();

export const getHistory = (): History => {
  return history;
};
